import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  approveClaim,
  resetUpdateSuccess,
} from "../../../redux/slice/claim/claimSlice";

const ApproveClaim = ({ claim_details }) => {
  const { approveSuccess } = useSelector((state) => state.claim);
  const { user } = useSelector((state) => state?.auth?.user);

  const closeRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (values) => {
    const payload = {
      ...values,
      claim_process_uuid: claim_details.id,
      claim_id: claim_details.claim_id,
      awaiting_status: claim_details.awaiting_status,
      policy_id: claim_details.policy_id,
      policy_cover: claim_details.policy_cover,
      staff_id: user?.staff_id,
      office_id: user?.office_id,
      current_date: moment().format("YYYY-MM-DD"),
      claim_amount: claim_details.claim_amount,
      customer_id: claim_details.customerId,
      policy_app_no: claim_details.policyAppNumber,
    };
    dispatch(approveClaim(payload));
    // closeRef.current.click()
  };

  //   const validationScehma = Yup.object().shape({
  //     approve_comment: Yup.string("").required(
  //       "Reason cannot be blank"
  //     ),
  //   });

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        approve_comment: "",
      },
      // validationSchema: validationScehma,
      onSubmit,
    });

  useEffect(() => {
    if (approveSuccess) {
      closeRef.current.click();
      dispatch(resetUpdateSuccess());
      navigate("/admin/pending-actions");
    }
  }, [approveSuccess, dispatch, navigate]);
  return (
    <div className='container'>
      <div className='my-3 text-center'>
        <h3 className='text-dark fs-3'>Approve Claim</h3>
        <p className='lh-sm fs-6'>
          Are you sure you want to approve this claim
        </p>
      </div>
      <div>
        <div className='row mb-3'>
          <div className='col-sm-12'>
            <label for='approve_comment' className='col-form-label'>
              Reason for Approving
            </label>
          </div>
          <div class='col-sm-12'>
            <textarea
              type='text'
              name='approve_comment'
              className='form-control form-control-sm'
              id='approve_comment'
              value={values?.approve_comment}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.approve_comment && touched?.approve_comment && (
              <p className='mb-0 text-danger'>
                {errors?.approve_comment + "*"}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='d-grid'>
          <button
            ref={closeRef}
            className='btn btn-sm mt-2 px-3 text-muted'
            data-bs-dismiss='modal'
            style={{ background: "#F1F0F1" }}
          >
            Cancel
          </button>
        </div>
        <div className='d-grid'>
          <button
            onClick={handleSubmit}
            className='btn btn-success btn-sm mt-2 px-3 text-white'
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveClaim;
